import { render } from "./ExperienceSection.vue?vue&type=template&id=2b0708d6"
import script from "./ExperienceSection.vue?vue&type=script&lang=js"
export * from "./ExperienceSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__